import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination'; // if you want pagination dots
import 'swiper/css/navigation'; // if you want arrows
import { Pagination } from 'swiper/modules';

const ServiceContent = [
  {
    icon: "ti-ruler-pencil",
    no: "01",
    service: "RESPONSIVE LAYOUTsss",
    title: "Responsive layout design meeting clients needs.",
    desc: `Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
    eiusmod tempor incididunt ut labore et dolore magna aliqua.`,
    animationDelay: "",
  },
  {
    icon: "ti-image",
    no: "02",
    service: "DEVELOPMENT",
    title: "Development gorgeous graphic design meeting clients needs.",
    desc: `Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
    eiusmod tempor incididunt ut labore et dolore magna aliqua.`,
    animationDelay: "150",
  },
  {
    icon: "ti-layout",
    no: "03",
    service: "GRAPHIC",
    title: "Graphic gorgeous design meeting clients needs.",
    desc: `Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
    eiusmod tempor incididunt ut labore et dolore magna aliqua.`,
    animationDelay: "300",
  },
  {
    icon: "ti-brush-alt",
    no: "04",
    service: "WEB DESIGN",
    title: "Web Design gorgeous graphic design meeting clients needs.",
    desc: `Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
    eiusmod tempor incididunt ut labore et dolore magna aliqua.`,
    animationDelay: "",
  },
  {
    icon: "ti-camera",
    no: "05",
    service: "MOTION GRAPHY",
    title: "Motion Graphy design meeting clients needs.",
    desc: `Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
    eiusmod tempor incididunt ut labore et dolore magna aliqua.`,
    animationDelay: "150",
  },
  {
    icon: "ti-world",
    no: "06",
    service: "PHOTOGRAPHY",
    title: "Photography design meeting clients needs.",
    desc: `Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
    eiusmod tempor incididunt ut labore et dolore magna aliqua.`,
    animationDelay: "300",
  },
];

const Staff = (props) => {
  return (
    <>
      <div className="row gy-4">
        <div className="row justify-content-center section-title text-center">
          <div className="col-lg-7">
            <h3 className="font-alt">{props.site.staffPageTitle}</h3>
            <p className="body">{props.site.staffDescription}</p>
          </div>
        </div>
        {/* {ServiceContent.map((val, i) => (
          <div
            className="col-sm-6 col-lg-4"
            key={i}
          >
            <div className="feature-box-02">
              <h6>
                {val.service}
              </h6>
              <p>{val.desc}</p>
            </div>
          </div>
        ))} */}

<Swiper
  spaceBetween={20}
  slidesPerView={1}
  pagination={{ clickable: true }}
  modules={[Pagination]}
  breakpoints={{
    768: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  }}
>
  {props.site.staff.map((val, i) => (
    <SwiperSlide key={i}>
      <div className="staff-box">
        <div style={{textAlign:"center"}}>
          <img style={{width:"11rem", borderRadius:"50%"}} src={process.env.REACT_APP_API_SERVICE_BASE_URL +'image/' + "BarberProfileImages/" + val.imageFileName}></img>
        </div>
      </div>
          <h6 className="heading-6" style={{textAlign:"center", borderBottom:"none", marginTop:"1rem"}}>
            {val.name}
          </h6>
    </SwiperSlide>
  ))}
</Swiper>
        
      </div>
    </>
  );
};

export default Staff;
